import { render, staticRenderFns } from "./SafetyStaffCreate.vue?vue&type=template&id=42d6a926&scoped=true"
import script from "./SafetyStaffCreate.vue?vue&type=script&lang=js"
export * from "./SafetyStaffCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d6a926",
  null
  
)

export default component.exports